import axios from "axios";
import authHeader from "./auth-header";
import { API_URL_COMMON } from "./http.common";

const API_URL = `${API_URL_COMMON}`;

// Sales promo codes (portal-backend /promo-codes, proxied to the website API).
class PromoService {
  list(params) {
    return axios({ method: "get", url: `${API_URL}/promo-codes`, headers: authHeader(), params });
  }

  plans() {
    return axios({ method: "get", url: `${API_URL}/promo-codes/plans`, headers: authHeader() });
  }

  get(id) {
    return axios({ method: "get", url: `${API_URL}/promo-codes/${id}`, headers: authHeader() });
  }

  create(data) {
    return axios({ method: "post", url: `${API_URL}/promo-codes`, headers: authHeader(), data });
  }

  update(id, data) {
    return axios({ method: "patch", url: `${API_URL}/promo-codes/${id}`, headers: authHeader(), data });
  }
}

const promoService = new PromoService();

export default promoService;
